import { CreditCard, Home, XCircle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import AuthenticatedLayout from '../components/AuthenticatedLayout'

export default function PaymentCancelledPage() {
    const navigate = useNavigate()

    const handleReturnToPricing = () => {
        navigate('/pricing')
    }

    const handleGoHome = () => {
        navigate('/dashboard')
    }

    return (
        <AuthenticatedLayout>
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl w-full">
                    {/* Cancel Card */}
                    <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 text-center">
                        {/* Cancel Icon */}
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-100 rounded-full mb-6">
                            <XCircle className="h-12 w-12 text-yellow-600" />
                        </div>

                        {/* Heading */}
                        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                            Payment Cancelled
                        </h1>

                        <p className="text-lg text-gray-600 mb-8">
                            Your payment was not processed. No charges have been made to your account.
                        </p>

                        {/* Info Box */}
                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-8 text-left">
                            <h3 className="text-lg font-semibold text-gray-900 mb-3">What happened?</h3>
                            <p className="text-sm text-gray-700 mb-4">
                                You cancelled the payment process before completion. This could be because:
                            </p>
                            <ul className="space-y-2 text-sm text-gray-700">
                                <li className="flex items-start gap-2">
                                    <span className="text-gray-400">•</span>
                                    <span>You clicked the back button during checkout</span>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="text-gray-400">•</span>
                                    <span>You closed the payment window</span>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="text-gray-400">•</span>
                                    <span>You decided to review pricing options</span>
                                </li>
                            </ul>
                        </div>

                        {/* Reassurance */}
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
                            <p className="text-sm text-blue-800">
                                <span className="font-semibold">Don&apos;t worry!</span> You can return to pricing and complete
                                your purchase whenever you&apos;re ready. Your account is safe and no payment was processed.
                            </p>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button
                                onClick={handleReturnToPricing}
                                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
                            >
                                <CreditCard className="h-5 w-5" />
                                Return to Pricing
                            </button>
                            <button
                                onClick={handleGoHome}
                                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-900 font-medium rounded-lg hover:bg-gray-200 transition-colors"
                            >
                                <Home className="h-5 w-5" />
                                Go to Dashboard
                            </button>
                        </div>
                    </div>

                    {/* Support Info */}
                    <div className="mt-8 text-center">
                        <p className="text-sm text-gray-600">
                            Questions about pricing? <a href="/help" className="text-blue-600 hover:text-blue-700 font-medium">Contact Support</a>
                        </p>
                    </div>
                </div>
            </div>
        </AuthenticatedLayout>
    )
}
